import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

export default function ProjectCard({ project }) {
  const isCompleted = project.status === "Completed";
  return (
    <Link to={`/projects/${project.slug}`} className="ye-project-card" data-testid={`project-card-${project.slug}`}>
      <div className="ye-project-photo">
        <img src={project.image} alt={project.title} loading="lazy" />
        <span className={`ye-status-chip ye-status-${isCompleted ? "completed" : "ongoing"}`}>
          {project.status}
        </span>
      </div>
      <div className="ye-project-body">
        <div className="ye-project-meta">
          <span className="ye-meta-pill"><MapPin size={13} /> {project.location}</span>
          <span className="ye-meta-pill ye-meta-pill--accent">{project.capacity}</span>
        </div>
        <h3 className="ye-h3" style={{ margin: "10px 0 8px" }}>{project.title}</h3>
        <p style={{ margin: "0 0 14px", fontSize: 14.5, color: "var(--ink)" }}>{project.summary}</p>
        <span className="ye-link-arrow">View project <ArrowRight size={14} /></span>
      </div>
    </Link>
  );
}
